import { render, staticRenderFns } from "./addDwgNotation.vue?vue&type=template&id=7f99f49d&scoped=true"
import script from "./addDwgNotation.vue?vue&type=script&lang=js"
export * from "./addDwgNotation.vue?vue&type=script&lang=js"
import style0 from "./addDwgNotation.vue?vue&type=style&index=0&id=7f99f49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f99f49d",
  null
  
)

export default component.exports